module.exports = __webpack_public_path__ + "img/Heart.467bacd7.svg";